module.exports = __webpack_public_path__ + "static/media/appleButton.161ec1f3.svg";